<script>
  export default {
    props: {
      last: {
        type: Boolean,
        default: false,
      },
      variant: {
        type: null,
        default: 'default',
      },
    },
    computed: {},
  }
</script>

<template>
  <div :class="['tree-item-wrapper mx-4', { 'last-item': last }]">
    <li class="tree-item pt-3">
      <div class="tree-item-content pd-12" :class="variant">
        <slot></slot>
      </div>
    </li>
  </div>
</template>
